import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import useLenis from "@/hooks/useLenis";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { WhySection } from "@/components/landing/WhySection";
import { Footer } from "@/components/landing/Footer";

function App() {
  useLenis();

  return (
    <div className="App relative min-h-screen bg-[#050505] text-white">
      <div className="noise-overlay" />
      <main>
        <Hero />
        <Marquee />
        <WhySection />
      </main>
      <Footer />
      <Toaster position="bottom-right" theme="dark" richColors />
    </div>
  );
}

export default App;
